var React = require('react');

function CopyIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3641","fillRule":"evenodd","d":"M5,17 C3.8954305,17 3,16.1045695 3,15 L3,7 C3,4.790861 4.790861,3 7,3 L15,3 C16.1045695,3 17,3.8954305 17,5 L7,5 C5.8954305,5 5,5.8954305 5,7 L5,17 Z M9,6 L18,6 C19.6568542,6 21,7.34314575 21,9 L21,18 C21,19.6568542 19.6568542,21 18,21 L9,21 C7.34314575,21 6,19.6568542 6,18 L6,9 C6,7.34314575 7.34314575,6 9,6 Z M9,8 C8.44771525,8 8,8.44771525 8,9 L8,18 C8,18.5522847 8.44771525,19 9,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,9 C19,8.44771525 18.5522847,8 18,8 L9,8 Z"}));
}

CopyIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CopyIcon;

CopyIcon.default = CopyIcon;
